module.exports = __webpack_public_path__ + "static/media/trial2.dfe46a2b.mp3";